export class PaymentSearchDTO{
  public document_date?:string
  public vendor_code?:string
  public purchase_order_no?:string
  public posting_date?:string
  public invoice_no?:string
  public miro_no?:string
  public amount?:string
  public payment_document_no?:string
  public clearing_document_no?:string
  public invoice_amount?:string
  public balance_amount?:string
  public description?:string
  public utr_no?:string
}
